<ps-ui-modal>
  <h5 psUiModalTitle class="modal-title w-100 text-center">Supplier Blend</h5>
  <ps-ui-modal-body class="px-5">
    <div class="row">
      <div class="col">
        <label class="blend-tile text-uppercase w-100">
          Supplier Blend Title
          <input
            type="text"
            class="form-control my-2"
            placeholder="Enter Supplier Blend Title"
            [(ngModel)]="title"
          />
        </label>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col">
        <div class="form-check">
          <label class="form-check-label text-uppercase">
            Default Blend
            <input
              type="checkbox"
              class="form-check-input"
              (change)="isDefaultChanged = true"
              [(ngModel)]="is_default"
            />
          </label>
        </div>
      </div>
    </div>
  </ps-ui-modal-body>
  <ps-ui-modal-footer class="justify-content-center">
    <div class="row">
      <div class="d-flex justify-content-center">
        <button psUiButton class="text-uppercase" (click)="save()">
          Save as blend
        </button>
      </div>
    </div>
  </ps-ui-modal-footer>
</ps-ui-modal>
